<script>
import { mapState, mapGetters } from 'vuex'
import date from 'locutus/php/datetime/date'
import long2ip from 'locutus/php/network/long2ip'
import ChildInfo from '@components/brokerage-console/child-info'
import { fetchRelationList } from '@apis/brokerage'
import fromPairs from 'lodash/fromPairs'

export default {
  components: { ChildInfo },
  data() {
    return {
      loading: false,
      list: [],
      search_params: {},
      show_brokerage_info: false,
      target_brokerage_seq: 0,
      target_parent_seq: 0,
    }
  },
  computed: {
    ...mapState('common', {
      constants: (state) => state.constants,
    }),
    ...mapGetters('brokerage', ['brokerage_info']),
  },
  watch: {
    $route(to, from) {
      this.page = this.$route.query.page || 1
      this.loadList().catch((e) => this.$toasted.error(e.message))
    },
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.page = this.$route.query.page || 1
      this.search_params = { ...this.$route.query }
      Promise.all([this.loadList()])
        .catch((e) => this.$toasted.error(e.message))
        .finally(() => {
          this.loading = false
        })
    },
    async loadList() {
      this.loading = true
      const ret_obj = await fetchRelationList({
        ...this.$route.params,
        ...this.$route.query,
        no_paging: 1,
      })

      this.list = ret_obj.data
    },
    date,
    fromPairs,
    long2ip,
    handleCreateBrokerage(target_parent_seq) {
      this.show_brokerage_info = true
      this.target_brokerage_seq = null
      this.target_parent_seq = target_parent_seq
    },
    handleUpdateBrokerage({ seq }) {
      this.show_brokerage_info = true
      this.target_brokerage_seq = seq
    },
    handleBrokerageSubmit(seq) {
      this.init()
      this.target_brokerage_seq = seq
    },
  },
}
</script>

<template>
  <div v-loading="loading">
    <ElDialog
      :title="
        target_brokerage_seq
          ? $t('child_list.modify_sub_brokerage')
          : $t('child_list.sub_broker_registration')
      "
      :visible.sync="show_brokerage_info"
    >
      <ChildInfo
        v-if="show_brokerage_info"
        :key="target_brokerage_seq"
        :brokerage_seq="target_brokerage_seq"
        :target_parent_seq="target_parent_seq"
        @submit="handleBrokerageSubmit"
      ></ChildInfo>
    </ElDialog>

    <h3 :class="$style.xeAdmin">{{ $t('child_list.List_sub_brokers') }}</h3>
    <fieldset :class="$style.clearfix">
      <div :class="$style.fl">
        <a href="#" :class="[$style.button]" @click.prevent="handleExportExcel"
          ><span>{{ $t('admin.excel_download') }}</span></a
        >
      </div>
      <div :class="$style.fr">
        <a
          href="#"
          :class="[$style.button, $style.green]"
          @click.prevent="handleCreateBrokerage(brokerage_info.seq)"
          ><span>{{ $t('child_list.new_sub') }}</span></a
        >
      </div>
    </fieldset>
    <table cellspacing="0" cellpadding="0" :class="$style.colTable">
      <thead>
        <tr>
          <th scope="col"
            ><div
              ><a href="#">{{ $t('admin.num') }}</a></div
            ></th
          >
          <th scope="col"
            ><div>{{ $t('child_list.title') }}</div></th
          >
          <th scope="col"
            ><div>{{ $t('child_list.broker_type') }}</div></th
          >
          <th scope="col"><div>&nbsp;</div></th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(data, idx) in list">
          <tr :key="data.seq" :class="$style[`bg${idx % 2}`]">
            <td :class="[$style.tCenter, $style.nowrap]">{{ data._no }}</td>
            <td :class="[$style.wide]"
              ><pre
                >{{ '\t'.repeat(data.depth) }}{{ data.child_title }}</pre
              ></td
            >
            <td :class="[$style.tCenter, $style.nowrap]">{{
              fromPairs(constants.brokerage.brokerage_type)[
                data.child_brokerage_type
              ]
            }}</td>
            <td :class="[$style.tRight, $style.nowrap]">
              <router-link
                :to="{
                  name: 'brokerage-console-child-view',
                  params: { ...$route.params, child_seq: data.child_seq },
                }"
                :class="[$style.button, $style.gray]"
                @click.prevent
                ><span>{{ $t('child_list.broker_details') }}</span></router-link
              >
              {{ ' ' }}
              <a
                href="#"
                :class="[$style.button, $style.green]"
                @click.prevent="handleCreateBrokerage(data.child_seq)"
                ><span>{{ $t('child_list.subpoint_registration') }}</span></a
              >
            </td>
          </tr>
        </template>
        <tr v-if="loading">
          <td :colspan="4" :class="$style.tCenter">{{
            $t('admin.loading')
          }}</td>
        </tr>
        <tr v-else-if="!list.length">
          <td :colspan="4" :class="$style.tCenter">{{
            $t('child_list.msg_no_sub')
          }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
@import '@src/design/button.scss';

.colTable th,
.colTable td {
  vertical-align: middle;
}
.colTable td pre {
  tab-size: 2;
}
</style>
